import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { ICurrency } from '@shared/data-access/interfaces';
import { CurrencyModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrencyApiService {
  static ROOT_POINT = 'finance/currencies';

  constructor(private _apiService: ApiService) {}

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<CurrencyModel>> {
    return this._apiService.get(CurrencyApiService.ROOT_POINT, query, option).pipe(map(data => new PaginationAdapter(CurrencyModel, data)));
  }
}
